
import { PS_TO_CS_STATUS_MAP } from '../constants/PsToCsStatusMap';

export function isStatusMatching(psStatus, standing) {
  if (!psStatus || !standing) return false;

  const statusObj = PS_TO_CS_STATUS_MAP[psStatus];
  const mapped = statusObj ? statusObj.status : undefined;
  if (!mapped) return false;

  return mapped.toLowerCase() === standing.toLowerCase();
}

export function getRecommendation(psStatus, standing) {
  if (!psStatus) {
    return null; // no update needed
  }

  const statusObj = PS_TO_CS_STATUS_MAP[psStatus];
  const expectedStatus = statusObj ? statusObj.status : undefined;

  if (!expectedStatus) {
    return null; // we dont know what update needed
  }

  if (expectedStatus.toLowerCase() !== standing?.toLowerCase()) {
    return {
      field: 'standing',
      value: expectedStatus,
      label: 'status'
    };
  }

  return null; // no update needed
}
